import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { APP_CONFIG, DeviceEnum, PAGE, PlanStepEnum, SearchItems } from '../../core';
import { ReceivedService } from '../../services';
import { BaseComponent, ReplaceLongLegPipe } from '../../shared';


@Component({
	selector: 'app-cloned-list-modal',
	templateUrl: './cloned-list-modal.component.html',
	imports: [
		ReplaceLongLegPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ClonedListModalComponent extends BaseComponent implements OnInit {

	public activeModal = inject(NgbActiveModal);
	private readonly receivedSrv = inject(ReceivedService);
	private readonly router = inject(Router);
	private readonly config = inject(APP_CONFIG);

	@Input() originalPlanGuid: string = '';
	@Input() originalPlanId: string = '';

	clonedList: SearchItems[] = [];


	ngOnInit(): void {
		this.receivedSrv.getClonedList(this.originalPlanGuid).subscribe(list => this.clonedList = list);
	}

	/**
	* Navigate to patient edit page.
	*/
	editPatient(patientGuid: string): void {
		if (patientGuid) {
			this.activeModal.close();
			this.router.navigate([`/${PAGE.PATIENT_EDIT}`], { queryParams: { patientGuid: patientGuid } });
		}
	}

	/**
	* Navigate to plan edit page.
	*/
	editPlan(planGuid: string): void {
		if (planGuid) {
			this.activeModal.close();
			this.router.navigate([`/${PAGE.PLAN_EDIT}`], { queryParams: { planGuid: planGuid } });
		}
	}

	/**
	* Navigate to ray site.
	*/
	navigateToApp(plan: SearchItems): void {
		if (plan) {
			let appRedirectUrl;
			if (plan.device === DeviceEnum.Tlhex) {
				appRedirectUrl = this.config.tlhexSite;
			} else if (plan.step === PlanStepEnum.RPM) {
				appRedirectUrl = this.config.fitboneSite;
			} else {
				appRedirectUrl = this.config.nextraySite;
			}
			this.activeModal.close();
			globalThis.location.href = `${appRedirectUrl}?caseGuid=${plan.planId}`;
		}
	}

}
